<template>
  <div class="home">
    <div class="filter-wrapper filter-wrapper-tab">
      <div class="link-filter-wrapper">
        <div>
          <v-select
            v-model="dataSelectLastDayValue"
            :options="dataSelectOptionsLastDay"
            :filterable="false"
            :searchable="false"
            :components="{ Deselect: dataComponentDeselect }"
            placeholder="Last Days"
            striped
            :class="[
              'call-select',
              dataSelectLastDayValue ? 'call-select--value' : null
            ]"
            @input="
              () => {
                if (!dataSelectLastDayValue) {
                  dataSelectLastDayValue = {
                    ...dataSelectLastDayValueDefault
                  };
                }
                $_ajax();
              }
            ">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
          </v-select>
          <v-select
            v-if="timeZoneOffset !== null"
            v-model="timeZoneOffset"
            label="name"
            :components="{ Deselect: dataComponentDeselect }"
            :class="[
              'call-select',
              dataSelectLastDayValue ? 'call-select--value' : null
            ]"
            :options="computedOffsetList"
            :filterable="false"
            :searchable="false"
            :clearable="false"
            striped
            @input="() => $_ajax()">
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                {{ option.name }}
              </div>
            </template>
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
          </v-select>
        </div>
        <div />
      </div>
    </div>

    <div
      v-if="dataStats"
      class="auto-call-detail-stats">
      <div class="auto-call-detail-stats__wrapper">
        <div
          v-for="(value, key) of configStats"
          :key="key"
          class="auto-call-detail-stats__block">
          <div class="auto-call-detail-stats__block-wrap">
            <div class="auto-call-detail-stats__label">
              <font-awesome-icon
                :style="{ color: value.color }"
                style="font-size: 16px;"
                :icon="value.icon" />
              {{ value.name }}
            </div>
            <div class="auto-call-detail-stats__count-stats">
              {{
                key === "calls_duration"
                  ? formatDuration(dataStats[key])
                  : dataStats[key]
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="filter-wrapper filter-wrapper-tab">
      <div class="link-filter-wrapper">
        <div>
          <call-input
            v-model="dataSearch"
            type-input="search"
            placeholder="Search Player ID"
            :enter-icon="true"
            @input="onSearchClear($event, 'dataSearch')"
            @enter="onSearch">
            <template slot="prefix">
              <font-awesome-icon :icon="dataIconSearch" />
            </template>
          </call-input>
          <div />
        </div>
        <div>
          <call-pagination
            page-calc
            :page-value="50"
            :obj-pagination="dataObjPagination"
            @on-pagination="$_ajax" />
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <b-table
        :show-empty="isLoaded"
        striped
        hover
        no-local-sorting
        :fields="dataMixinAutoCallDetalsFields"
        :items="dataAutoCall"
        sort-by="created_at"
        :sort-desc="true"
        @sort-changed="onSortTabel"
        @row-hovered="onHover"
        @row-unhovered="onUnHover">
        <template #empty>
          <EmptyTable />
        </template>
        <template #cell(call_status)="data">
          <span :class="`table-status-${data.item.call_status}`">
            {{ (data.item.call_status || "").replace("_", " ") }}
          </span>
        </template>
        <template #cell(call_duration)="data">
          {{ formatDuration(data.item.call_duration) }}
        </template>
        <template #cell(call_created_at)="data">
          {{ data.item.call_created_at | dateFilter }}
        </template>
        <template #cell(created_at)="data">
          {{ data.item.created_at | dateFilter }}
        </template>
        <template #cell(status)="data">
          <span :class="`table-status-${data.item.status}`">
            {{ data.item.status }}
          </span>
        </template>
        <template #cell(type)="data">
          <span :class="`table-type-${data.item.type}`">
            {{ data.item.type }}
          </span>
        </template>
        <template #cell(days)="data">
          {{ data.item.settings.days.join(", ") }}
        </template>
        <template #cell(time)="data">
          {{ data.item.settings.period_start.slice(0, 5) }}
          - {{ data.item.settings.period_end.slice(0, 5) }}
        </template>
        <template #cell(settings.tasks_count)="data">
          {{
            data.item.settings.tasks_all
              ? "All"
              : data.item.settings.tasks_count
          }}
        </template>
        <template #cell(actions)="data">
          <div class="ac-actions-wr">
            <CallDetailsTableActions
              :data="{
                item: data.item,
                permissions: dataObjPermissions[data.item.id]
              }"
              :disabled="false"
              @on-action="value => onActions(data.item, value)" />

            <CallTableAutoCallDetailActions
              v-if="data.item.prev_calls && data.item.prev_calls.length"
              :rotate="data.item._showDetails"
              @on-action="value => onActions(data, value)" />
          </div>
        </template>
        <template #row-details="row">
          <b-table
            v-if="row.item.prev_calls && row.item.prev_calls.length"
            hover
            no-local-sorting
            table-class="deposits-subtable ac-seb-table"
            :fields="dataMixinSubAutoCallDetalsFields"
            :items="
              row.item.prev_calls.map(item => {
                item.actions = '';
                return item;
              })
            "
            tbody-tr-class="row-blue"
            @row-hovered="onHover"
            @row-unhovered="onUnHover">
            <template #empty>
              <EmptyTable />
            </template>
            <template #cell(created_at)="data">
              {{ data.item.created_at | dateFilter }}
            </template>
            <template #cell(duration)="data">
              {{ formatDuration(data.item.duration) }}
            </template>
            <template #cell(status)="data">
              <span :class="`table-status-${data.item.status}`">
                {{ (data.item.status || "").replace("_", " ") }}
              </span>
            </template>
          </b-table>
        </template>
      </b-table>
    </div>

    <CallModal
      v-model="isOpenModal"
      :data="dataModal"
      use-view="AutoCallsDetail"
      @input="handlerModal" />

    <CallUpdateNameAutoCall
      v-model="isOpenModalName"
      :run-id="runId"
      :name="nameAutoCallRun"
      @on-update="handlerRename" />
  </div>
</template>

<script>
import CallPagination from '@/components/desktop/CallPagination';

import CallDetailsTableActions from '@/components/desktop/CallDetailsTableActions';
import CallUpdateNameAutoCall from '@/components/common/modals/CallUpdateNameAutoCall';
import CallTableAutoCallDetailActions from '@/components/desktop/CallTableAutoCallDetailActions';

import {
  AUTOCALL_GET_RUN_TASKS,
  AUTOCALL_GET_RUN,
  AUTOCALL_GET_RUN_STATS,
  TEAMS_GET,
  AUTOCALL_UPDATE_TASK_RUN_STATUS
} from '../../../store/types/actions.types';
import {
  faCommentMedical,
  faSearch,
  faChevronDown,
  faPhone as farPhone,
  faTasks as farTasks
} from '@fortawesome/pro-regular-svg-icons';
import { faPhone, faTasks } from '@fortawesome/pro-solid-svg-icons';

import helper from '../../../service/helper';
import { mapGetters } from 'vuex';
import autoCallProjectTable from '@/mixins/table/autoCallProjectTable';
import { BTable } from 'bootstrap-vue';
import moment from 'moment';
import CallInput from '@/components/common/CallInput';
import selectReportPeriod from '../../../mixins/select/selectReportPeriod';
import CallModal from '@/components/common/modals/CallModal.vue';

export default {
  name: 'AutoCallsDetail',
  components: {
    BTable,
    CallInput,
    CallDetailsTableActions,
    CallTableAutoCallDetailActions,
    CallPagination,
    CallModal,
    CallUpdateNameAutoCall
  },
  mixins: [autoCallProjectTable, selectReportPeriod],
  data () {
    return {
      isOpenModalName: false,
      dataModal: null,
      isOpenModal: false,
      isLoaded: false,
      projectId: null,
      computedOffsetList: null,
      firstLoad: true,
      timeZoneOffset: null,
      teamId: null,
      configStats: {
        tasks_count: {
          icon: faTasks,
          name: 'Tasks',
          color: '#222222'
        },
        tasks_running_count: {
          icon: farTasks,
          name: 'Tasks Running',
          color: '#e96c2c'
        },
        tasks_complete_count: {
          icon: farTasks,
          name: 'Tasks Complete',
          color: '#20a052'
        },
        calls_count: {
          icon: faPhone,
          name: 'All Call',
          color: '#222222'
        },
        calls_successful_count: {
          icon: farPhone,
          name: 'Finished',
          color: '#20a052'
        },
        calls_failed_count: {
          icon: farPhone,
          name: 'Cancelled',
          color: '#dd2f43'
        },
        calls_duration: {
          icon: farPhone,
          name: 'Spoken',
          color: '#222222'
        }
      },
      nameAutoCallRun: '',
      dataObjPagination: {},
      dataObjPermissions: {},
      dataDesc: true,
      dataOrderBy: 'created_at',
      dataSearch: null,
      dataTaskDetail: {},
      dataProjectOptions: {},
      dataIconDown: faChevronDown,
      dataIconAddComment: faCommentMedical,
      dataIconSearch: faSearch,
      dataShowReAssign: false,
      dataShowReSchedule: false,
      dataShowCloseTask: false,
      dataShowAddComment: false,
      dataShowDeleteComment: false,
      dataShowEditComment: false,
      dataShowAddIssue: false,
      dataShowEditIssue: false,
      dataShowDeleteIssue: false,
      dataPropsCallId: null,
      dataPropsEditIssue: {},
      dataPropsComment: {},
      dataModalTitle: null,
      runId: null,
      runName: null,
      dataStats: null,
      dataAutoCall: []
    };
  },
  computed: {
    ...mapGetters({
      computedStoreCurrentUser: 'auth/currentUser',
      computedIsOperator: 'auth/isOperator',
      computedIsModerator: 'auth/isModerator',
      computedCurrentUser: 'auth/currentUser',
      computedIsAdmin: 'auth/isAdmin'
    }),

    computedTeamsIds () {
      return this.computedStoreCurrentUser.teams.map(item => item.id);
    },

    computedLabel () {
      return this.dataSelectLastDayValue?.label || 'Today';
    }
  },

  async created () {
    this.runId = this.$route.params.id;
    this.isLoaded = false;
    // this.runName = this.$route.query.name;

    this.$_ajax = ((options = {}) => {
      let _page = 0;
      let _limit = 50;

      const { currentRoute: { name: pageName } = {} } = this.$router;

      const _filterKey = `_filter${pageName}`;

      if (!helper.isEmpty(this.$route.query, _filterKey)) {
        try {
          options = helper.clearObject(
            JSON.parse(this.$route.query[_filterKey])
          );

          const _arrFilter = [
            'id',
            'desc',
            'orderBy',
            'limit',
            'page',
            'search',
            'name',
            'period'
          ];

          for (const _key of _arrFilter) {
            if (!helper.isEmpty(options, _key)) {
              switch (_key) {
                case 'id':
                  this.runId = options[_key];
                  break;
                case 'name':
                  this.nameAutoCallRun = options[_key];
                  break;
                case 'search':
                  this.dataSearch = options[_key];
                  break;
                case 'desc':
                  this.dataDesc = options[_key];
                  break;
                case 'orderBy':
                  this.dataOrderBy = options[_key];
                  break;
                case 'limit':
                  _limit = options[_key];
                  break;
                case 'page':
                  _page = options[_key];
                  break;
                case 'period':
                  this.dataSelectLastDayValue = options[_key];
                  break;
              }
            }
          }
        } catch (e) {
          console.log('Error query params');
        }
      }

      return async ({
        id = this.runId,

        desc = this.dataDesc,
        orderBy = this.dataOrderBy,
        teamId = this.teamId,
        projectId = this.dataSelectProject,
        issuesId = this.dataSelectIssueValue,
        limit = null,
        page = null,
        reset = false,
        search = this.dataSearch
      } = options) => {
        this.$store.dispatch('loading/startLoading');

        try {
          if (!this.dataSelectLastDayValue) {
            this.dataSelectLastDayValue = {
              ...this.dataSelectLastDayValueDefault
            };
          }

          if (!helper.isEmpty(page) && page !== _page) {
            _page = page;
          }

          if (!helper.isEmpty(limit) && limit !== _limit) {
            _limit = limit;
          }

          if (reset) {
            _page = 0;
          }

          const [
            { payload = [], misc: { paging = {}, permissions = {} } = {} }
          ] = await Promise.all([
            this.$store.dispatch(
              `autocall/${AUTOCALL_GET_RUN_TASKS}`,
              helper.clearObject({
                id: id,
                params: {
                  search,
                  desc,
                  order_by: orderBy,
                  limit: _limit,
                  page: _page
                }
              })
            ),
            this.getAutoCallRun(id)
          ]);

          await this.getTeam();

          await this.getStats(id);

          this.dataObjPermissions = permissions;
          this.dataObjPagination = paging;
          this.dataAutoCall = payload;

          this.$router
            .replace({
              ...this.$router.currentRoute,
              query: {
                [_filterKey]: JSON.stringify(
                  helper.clearObject({
                    id,
                    name: this.nameAutoCallRun,
                    desc,
                    search,
                    period: this.dataSelectLastDayValue,
                    orderBy,
                    team_ids: teamId,
                    project_ids: projectId,
                    issue_id: issuesId,
                    limit: _limit,
                    page: _page,
                    operator_ids: this.computedIsOperator
                      ? [this.computedCurrentUser]
                      : this.dataSelectOperatorValue,
                    statuses: this.filterPhone
                  })
                )
              }
            })
            .catch(() => {});

          options = {};
          this.isLoaded = true;
          // this.breadcrumbParamsSave();
        } finally {
          this.$store.dispatch('loading/stopLoading');
        }
      };
    })();

    this.$_ajax();
  },

  async mounted () {
    this.$root.$on('clickEditIcon', (item) => {
      this.isOpenModalName = true;
    });
  },

  destroyed () {
    this.$root.$off('clickEditIcon');
  },

  methods: {
    handlerRename () {
      this.$_ajax({ reset: true });
      this.isOpenModalName = false;
    },

    handlerModal (action) {
      if (action === 'cancel') {
        this.isOpenModal = false;
        this.dataModal = null;
      }
      if (action === 'confirm') {
        const { id, action: actionApi } = this.dataModal;
        this.updateAutoCallTaskStatus(id, actionApi);
        this.isOpenModal = false;
        this.dataModal = null;
      }
    },

    async updateAutoCallTaskStatus (id, action) {
      try {
        await this.$store.dispatch(`autocall/${AUTOCALL_UPDATE_TASK_RUN_STATUS}`, {
          id,
          params: helper.clearObject({
            action
          })
        });
        this.$_ajax({ reset: true });
      } catch (error) {
        console.log(error);
      }
    },

    async onActions (data, action) {
      const { task_id, player_id, id } = data;

      switch (action) {
        case 'view':
          if (this.projectId === null) return;
          this.$router.push({
            name: 'CallTasksDetail',
            params: {
              taskId: task_id,
              projectId: this.projectId
            },
            query: {
              ...(this.$route.query || {}),
              taskName: 'ID: ' + player_id
            }
          });
          break;
        case 'toggle':
          data.toggleDetails();
          break;
        case 'play':
          this.updateAutoCallTaskStatus(id, 'resume');
          break;
        case 'pause':
          this.updateAutoCallTaskStatus(id, 'pause');
          break;
        case 'stop':
          this.isOpenModal = true;
          this.dataModal = { id, action: 'stop', ...data };
          break;
      }
    },
    async getStats (id) {
      try {
        const { payload: payloadStats = {} } = await this.$store.dispatch(
          `autocall/${AUTOCALL_GET_RUN_STATS}`,
          helper.clearObject({
            id: id,
            params: {
              period: this.dataSelectLastDayValue?.key || 'day',
              timezone: this.timeZoneOffset?.id
            }
          })
        );

        this.dataStats = payloadStats;
      } catch (error) {
        console.log(error);
      }
    },

    async getTeam () {
      if (this.firstLoad) {
        const { team = {} } = await this.$store.dispatch(`team/${TEAMS_GET}`, {
          params: {
            id: this.teamId
          }
        });
        this.timeZoneOffset = this.$store.state.team.utc.find(
          item => item.id === team.timezone_offset
        );
        if (team.timezone_offset === 0) {
          this.computedOffsetList = [
            {
              id: 0,
              name: this.$store.state.team.utc.find(item => item.id === 0).name
            }
          ];
        } else {
          this.computedOffsetList = [
            {
              id: this.timeZoneOffset.id,
              name: this.$store.state.team.utc.find(
                item => item.id === this.timeZoneOffset.id
              ).name
            },
            {
              id: 0,
              name: this.$store.state.team.utc.find(item => item.id === 0).name
            }
          ];
        }
        this.firstLoad = false;
      }
    },
    async getAutoCallRun (id) {
      // if (!this.firstLoad) {
      //   return;
      // }
      try {
        const { payload = [] } = await this.$store.dispatch(
          `autocall/${AUTOCALL_GET_RUN}`,
          helper.clearObject({
            id: id,
            params: {}
          })
        );

        this.projectId = payload.project_id;
        this.teamId = payload.team_id;
        this.nameAutoCallRun = payload.name;
      } catch (error) {
        console.log(error);
      }
    },

    onSearchClear (e, flag) {
      const { currentRoute: { name: pageName } = {} } = this.$router;
      const _filterKey = `_filter${pageName}`;

      const { search = '' } = JSON.parse(
        this.$route.query[_filterKey]
      );
      if (flag === 'dataSearch' && search && !this.dataSearch) {
        this.$_ajax({ reset: true });
      }
    },
    onSearch () {
      this.$_ajax({ reset: true });
    },

    formatDuration (time) {
      if (time === null) return '';
      const duration = moment.duration(time);

      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      return `${hours}h ${minutes}m ${seconds}s`;
    },

    onSortTabel ({ sortBy, sortDesc }) {
      this.dataDesc = sortDesc;
      this.dataOrderBy = sortBy;
      this.$_ajax();
    }
  }
};
</script>

<style lang="scss" scoped>
.ac-actions-wr {
  display: flex;
  width: 140px;
}

::v-deep {
  .table-status {
    &-running,
    &-in_progress {
      color: #e96c2c;
      text-transform: capitalize;
    }
    &-complete,
    &-success,
    &-successful {
      color: #20a052;
      text-transform: capitalize;
    }
    &-cancelled,
    &-rejected,
    &-stopped,
    &-failed {
      color: #dd2f43;
      text-transform: capitalize;
    }
    &-no_answer {
      color: #222222;
      text-transform: capitalize;
    }
  }
}

.auto-call-detail-stats {
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);
  background-color: #fff;
  margin-bottom: 17px;
  &__wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  &__block {
    flex: 1;
  }

  &__label {
    font-size: 16px;
    font-weight: 600;
    color: #222;
  }
  &__count-stats {
    font-size: 24px;
    color: #222;
  }
}
</style>
